import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import I18n from 'I18n';
import styled from 'styled-components';
import { getRefreshUrl } from '../helpers/getRefreshUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const POPOVER_ILLUSTRATION_WIDTH = 130;
const StyledErrorMessage = styled(UIErrorMessage).withConfig({
  displayName: "UniversalAssociationsSelectError__StyledErrorMessage",
  componentId: "y6wj0f-0"
})(["img{margin-bottom:16px;}"]);
const UniversalAssociationsSelectError = () => {
  return /*#__PURE__*/_jsx(StyledErrorMessage, {
    className: "m-top-4 m-right-10 m-bottom-4 m-left-10",
    illustrationProps: {
      width: POPOVER_ILLUSTRATION_WIDTH
    },
    title: I18n.text('universalAssociationsSelect.errorSorry'),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        Link: UILink
      },
      message: "universalAssociationsSelect.error_jsx",
      options: {
        href: getRefreshUrl()
      }
    })
  });
};
export default UniversalAssociationsSelectError;